import { getParameterByName } from 'helpers/Query';

import * as experiments from './experiments';
import * as features from './features';

export const generalExperiments = [
    experiments.ShowProductsOnPaymentStep,
    experiments.ClickCollectAvailableBeforeZipin,
    experiments.AciNotification,
    experiments.DiscountCode,
    experiments.HideBgImage,
];

/**
 * Short-hand function for window.Checkout.optimizely
 */
export const optimizely = () => window.Checkout.optimizely || {};

export const createInstance = (datafile) => {
    optimizely().datafileKey = null;
    optimizely().environment = null;

    if (window.location.href.includes('localhost')) {
        optimizely().datafileKey = 'J9NgqW52euDh6afBvMystL';
        optimizely().environment = 'development';
    }

    if (window.location.href.includes('ikeadt.com')) {
        optimizely().datafileKey = '7GQQSHmU3AZAQEMEiGZj8f';
        optimizely().environment = 'staging';
    }

    if (window.location.href.includes('ikea.com')) {
        optimizely().datafileKey = 'LpYmrcSUHchWhCap3CGx5V';
        optimizely().environment = 'production';
    }

    if (datafile) {
        return Promise.resolve(window.optimizelySdk.createInstance({
            datafile: datafile,
        }));
    }

    if (!optimizely().datafileKey) {
        return Promise.reject();
    }

    return fetch(`https://cdn.optimizely.com/datafiles/${optimizely().datafileKey}.json`, { mode: 'cors' })
        .then(response => response.json())
        .then(data => {
            return window.optimizelySdk.createInstance({
                datafile: data,
            });
        })
        .catch(e => console.error(e)); // eslint-disable-line no-console
};

export const activateExperiments = (country, userId, experimentList) => {
    if (!optimizely().environment || !optimizely().sdk.activate) {
        return;
    }

    const attributes = {
        market: country.toUpperCase(),
        environment: optimizely().environment,
    };

    const experimentIsNotActive = experiment => {
        return !optimizely().experiments || !Object.keys(optimizely().experiments).includes(experiment);
    };

    const experimentConfigurations = experimentList
        .filter(({ name }) => experimentIsNotActive(name))
        .map(({ name }) => optimizely().sdk.activate(name, userId, attributes));

    const queryExp = getParameterByName('experiments');
    if (queryExp) {
        queryExp.split(',').forEach(e => {
            const expInfo = e.split(':');
            experimentConfigurations[expInfo[0]] = expInfo[1];
        });
    }

    if (!optimizely().experiments) {
        optimizely().experiments  = experimentConfigurations;
        optimizely().track = eventName => optimizely().sdk.track(eventName, userId, attributes);
    } else {
        optimizely().experiments = {...optimizely().experiments, ...experimentConfigurations };
    }

    return;
};

export const experiment = experimentName => {
    if (!optimizely().experiments ||
        !Object.keys(optimizely().experiments).length) {
        return undefined;
    }

    // return the variation value
    return optimizely().experiments[experimentName];
};

export const getFeatureConfigurations = userId =>
    Object.values(features).reduce((obj, feature) => ({
        ...obj,
        [feature]: optimizely()?.sdk?.isFeatureEnabled(feature, userId),
    }), {});

/**
 * @example isExperimentVariationActive(experiments.ShowProductsOnPaymentStep, variations => variations.Show)
 */
export const isExperimentVariationActive = ({ name, variations }, variation) => {
    const variationName = typeof variation === 'function'
        ? variation(variations)
        : variation;

    return optimizely()?.experiments?.[name] === variationName;
};
